<script setup>
import { onMounted, ref } from 'vue';
import { collectionV2 } from '@/composables/resource';
import { useStore } from '@/store';
import { useToast } from '@/plugins/toast';
import axios from '@/axios';

import IconContentCopy from '@/components/Icons/ContentCopy.vue';
import UserList from '@/components/User/UserList.vue';

const store = useStore();
const toast = useToast();
const stats = ref(null);

const referrals = collectionV2({
    url: '/api/referrals',
});

const appUrl = import.meta.env.VITE_APP_URL;
const referralLink = `${appUrl}/auth/register/?ref=${store.state.user.referral_code}`;

const copyReferralLink = () => {
    navigator.clipboard.writeText(referralLink)
        .then(() => {
            toast.info('Referral link copied');
        })
        .catch((error) => {
            toast.error('Failed to copy referral link to clipboard');
            console.error(error);
        });
};

onMounted(() => {
    referrals.fetch();
    axios.get('/api/referral-stats').then((res) => {
        stats.value = res.data;
    });
});
</script>

<template>
    <layout-main>
        <layout-content>
            <content-header>
                <top-nav>
                    <top-nav-back />
                    <top-nav-title>
                        Your Referrals
                    </top-nav-title>
                </top-nav>
            </content-header>

            <content-body>
                <div class="mt-3 px-4">
                    <div class="text-sm">
                        Referral Link:
                        <button type="button" aria-label="Copy referral code" @click="copyReferralLink">
                            <span class="font-semibold">{{ referralLink }}</span><IconContentCopy class="inline ml-1 size-4" />
                        </button>
                    </div>
                    <div v-if="stats" class="text-sm">
                        Total Active: {{ stats.total_active }}
                    </div>
                    <div v-if="stats" class="text-sm">
                        Total Pending: {{ stats.total_pending }}
                    </div>
                    <UserList class="mt-3" :collection="referrals" />
                </div>
            </content-body>
        </layout-content>
    </layout-main>
</template>
